import { registerBlockType } from '@wordpress/blocks'; 
import { BlockAlignmentToolbar, BlockControls, InspectorControls, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import { Button, Toolbar, IconButton, Panel, PanelBody, PanelRow, TextControl, DateTimePicker, Icon } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';
import { element, Fragment, useState, useEffect } from '@wordpress/element';
import { __experimentalGetSettings } from '@wordpress/date';
import { withState } from '@wordpress/compose';
import Cropper from 'react-cropper';


const el = React.createElement;
const cropperRef = React.createRef();

const soIcon = el('svg', { className: 'soIcon', width: '166.000000pt', height: '155.000000pt',  preserveAspectRatio:"xMidYMid meet", viewBox:"0 0 166.000000 155.000000" },
	el('g', {transform:"translate(0.000000,155.000000) scale(0.100000,-0.100000)", fill:"#000000", stroke:"none"},
	    el('path', { d: "M880 774 l0 -779 98 95 c339 330 682 677 682 691 0 15 -748 759 -771 767 -5 2 -9 -301 -9 -774z" } ),
	    el('path', { d: "M0 767 c0 -13 751 -757 764 -757 3 0 6 173 6 385 l0 385 -385 0 c-315 0 -385 -2 -385 -13z" } )
	)
);

const sSmallIcon = () => (
    <Icon icon={ <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path stroke="null" id="svg_1" fill-rule="evenodd" fill="#010101" d="m14.953703,6.452965c0,0.410933 0.333676,0.744479 0.74461,0.744479c0.410868,0 0.744544,-0.333578 0.744544,-0.744479c0,-0.410966 -0.333676,-0.744544 -0.744544,-0.744544c-0.410966,0 -0.74461,0.333578 -0.74461,0.744544zm-7.44495,4.020342l0,0.818949c0,0.369339 0.300702,0.670008 0.670041,0.670008l8.264031,0l-2.847197,-2.799309c-0.238228,-0.238326 -0.619432,-0.238326 -0.857267,0l-0.601765,0.592587l-1.518916,-1.485975c-0.238195,-0.238326 -0.666894,-0.238326 -0.902139,0l-2.206788,2.203739zm-2.680195,5.062573c0,0.658142 0.533096,1.191172 1.19114,1.191172l11.912085,0c0.65811,0 1.19114,-0.53303 1.19114,-1.191172l0,-11.316449c0,-0.658142 -0.53303,-1.191205 -1.19114,-1.191205l-11.912052,0c-0.658077,0 -1.19114,0.533096 -1.19114,1.191205l0,11.316449l-0.000033,0zm2.144248,-11.018599l10.005933,0c0.363307,0 0.655225,0.291787 0.655225,0.655192l0,7.325804c0,0.363242 -0.291918,0.655127 -0.655225,0.655127l-10.005933,0c-0.363275,0 -0.655258,-0.291885 -0.655258,-0.655127l0,-7.325804c-0.000033,-0.363406 0.291983,-0.655192 0.655258,-0.655192z" clip-rule="evenodd"/>
 </g>
</svg> } />
);

const sMediumIcon = () => (
    <Icon icon={ <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path stroke="null" id="svg_1" fill-rule="evenodd" fill="#010101" d="m14.802511,7.322292c0,0.515244 0.418376,0.933455 0.93362,0.933455c0.515161,0 0.933537,-0.418253 0.933537,-0.933455c0,-0.515285 -0.418376,-0.933537 -0.933537,-0.933537c-0.515285,0 -0.93362,0.418253 -0.93362,0.933537zm-9.334758,5.040856l0,1.02683c0,0.46309 0.377032,0.840081 0.840122,0.840081l10.361752,0l-3.569923,-3.509879c-0.298699,-0.298822 -0.776667,-0.298822 -1.074873,0l-0.754515,0.743008l-1.904474,-1.863171c-0.298658,-0.298822 -0.836177,-0.298822 -1.131136,0l-2.766953,2.763131zm-3.360529,6.347644c0,0.825204 0.668415,1.493537 1.493496,1.493537l14.935818,0c0.825162,0 1.493496,-0.668333 1.493496,-1.493537l0,-14.188988c0,-0.825204 -0.668333,-1.493578 -1.493496,-1.493578l-14.935777,0c-0.825121,0 -1.493496,0.668415 -1.493496,1.493578l0,14.188988l-0.000041,0zm2.688539,-13.815532l12.545814,0c0.455528,0 0.821546,0.365853 0.821546,0.821505l0,9.185367c0,0.455446 -0.366017,0.821423 -0.821546,0.821423l-12.545814,0c-0.455487,0 -0.821587,-0.365976 -0.821587,-0.821423l0,-9.185367c-0.000041,-0.455652 0.3661,-0.821505 0.821587,-0.821505z" clip-rule="evenodd"/>
 </g>
</svg> } />
);

const sWideIcon = () => (
    <Icon icon={ <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg">
 <g>
  <path stroke="null" id="svg_1" fill-rule="evenodd" fill="#010101" d="m16.730116,7.974287c0,0.593476 0.481901,1.075188 1.075377,1.075188c0.593382,0 1.075282,-0.481759 1.075282,-1.075188c0,-0.593524 -0.481901,-1.075282 -1.075282,-1.075282c-0.593524,0 -1.075377,0.481759 -1.075377,1.075282zm-10.752113,5.80624l0,1.18274c0,0.533404 0.434279,0.967636 0.967683,0.967636l11.935042,0l-4.111967,-4.042806c-0.344052,-0.344194 -0.894593,-0.344194 -1.238078,0l-0.869078,0.855823l-2.193642,-2.146067c-0.344005,-0.344194 -0.963139,-0.344194 -1.302883,0l-3.187077,3.182675zm-3.87078,7.311446c0,0.950499 0.769905,1.72031 1.720262,1.72031l17.203617,0c0.950452,0 1.720262,-0.76981 1.720262,-1.72031l0,-16.343391c0,-0.950499 -0.76981,-1.720357 -1.720262,-1.720357l-17.20357,0c-0.950405,0 -1.720262,0.769905 -1.720262,1.720357l0,16.343391l-0.000047,0zm3.096756,-15.913231l14.450724,0c0.524694,0 0.946286,0.421403 0.946286,0.946239l0,10.580039c0,0.5246 -0.421592,0.946144 -0.946286,0.946144l-14.450724,0c-0.524647,0 -0.946334,-0.421545 -0.946334,-0.946144l0,-10.580039c-0.000047,-0.524836 0.421687,-0.946239 0.946334,-0.946239z" clip-rule="evenodd"/>
 </g>
</svg> } />
);

registerBlockType( 'squareoffs/blocks', {
    title: 'SquareOffs',
    icon: soIcon,
    category: 'embed',
    attributes: {
	    soAlignment: {
	    	type: 'string',
	        default : 'left'
	    },
	    soID: {
	    	type: 'number'
	    },
	    soSize: {
	    	type: 'string',
	        default : 'wide'
	    },
	    soStep: {
	    	type: 'number',
	        default: 0
	    },
    	question: {type: 'string'},
    	side_1_title: {type: 'string'},
    	side_2_title: {type: 'string'},
    	side_1_defense: {type: 'string'},
    	side_2_defense: {type: 'string'},
    	side_1_photo: {type: 'string'},
    	side_1_photo_raw: {type: 'string'},
    	side_2_photo: {type: 'string'},
    	side_2_photo_raw: {type: 'string'},
    	end_date: {type: 'string'},
    	category_uuid: {type: 'string'},
    	tag_list: {type: 'string'},
    	cover_photo: {type: 'string'},
    	cover_photo_raw: {type: 'string'},
    	cover_photo_mime: {type: 'string'},
	    side1MediaID :{type:'string'},
	    side2MediaID :{type:'string'},
	    coverPhotoMediaID :{type:'string'},
	    showRequired :{type:'number'},
	},
    edit: function(props) {
		const [dateTimePickerFocus, setDateTimePickerFocus] = useState(false);
		const [createSoStateDone, setCreateSoStateDone] = useState(false);

		useEffect(() => {
		    console.log("CB: ",dateTimePickerFocus);
		    console.log("DONE: ",createSoStateDone);
		  }, [dateTimePickerFocus, createSoStateDone]);


		const fetchStep = 4;
		const finalStep = 5;
    	const handleEndDateFocus = (event) => {
    		event.preventDefault();
    		event.stopPropagation();
    	  	setDateTimePickerFocus(true);
    	};

    	const closeDatePicker = (event) => {
			event.preventDefault();
    		event.stopPropagation();
    		setDateTimePickerFocus(false);
    	};

    	function updateSOStep(event) {
	        event.preventDefault();
	        console.log(props.attributes.soStep," == ",fetchStep);
	        var proceed = false;
	        console.log(props.attributes);
	        if(props.attributes.soStep == 1){
	        	if(props.attributes.question && props.attributes.side_1_title && props.attributes.side_2_title) {
	        		proceed = true;
		        }else{
		        	props.setAttributes({showRequired:1});
		        	console.log("dddd");
		        }
		    }else if(props.attributes.soStep == 3){
			    if(props.attributes.category_uuid) {
		        	proceed = true;
		        }else{
		        	props.setAttributes({showRequired:3});
		        }
		    }else if(props.attributes.soStep == 0 || props.attributes.soStep == 2) proceed = true;

	        if(proceed === true){
		        if(parseInt(props.attributes.soStep) + 1 == fetchStep){
		        	if(props.attributes.question && props.attributes.side_1_title && props.attributes.side_2_title && props.attributes.category_uuid){
		        		createSquareOffs();
		        		props.setAttributes({soStep: parseInt(props.attributes.soStep) + parseInt(1)});
		        	}
		        }else{
		        	props.setAttributes({soStep: parseInt(props.attributes.soStep) + parseInt(1)});
		        }
		    }
	    }

	    
	    async function createSquareOffs(){
	    	var form_data = new FormData();
			for ( var key in props.attributes ) {
			    form_data.append(key, props.attributes[key]);
			}

			form_data.append('action', 'soCreateSquareOffs');
	    	console.log("fetching...");
	    	console.log(form_data);
	    	await fetch( window.ajaxurl, {
    	            method: 'POST',
    	            body: form_data
    	        })
		    	.then(response => response.json())
	  			.then(data => doneCreatingSquareOffs(data));
	    }
	    function doneCreatingSquareOffs(data){
	    	console.log(data);
	    	props.setAttributes({soID: data.external_id});
	    	props.setAttributes({soStep: finalStep});
	    }
	    function backSOStep(event){
	    	event.preventDefault();
	    	console.log(props.attributes);
	    	props.setAttributes({soStep: parseInt(props.attributes.soStep) - parseInt(1)});
	    }
    	function sOStepExisting(event) {
	        event.preventDefault();
	        props.setAttributes({soStep: 10});
	    }
    	function sOStepCancel(event) {
	        event.preventDefault();
	        props.setAttributes({soStep: 0});
	    }
    	function injectSOShortcode(event) {
		    if(props.attributes.soID && props.attributes.soSize && props.attributes.soAlignment) props.setAttributes({soStep: finalStep});
	    }

		const soUpdateSOID = ( event ) => {
			event.preventDefault();
			if(event.key){
				if("Enter" == event.key) props.setAttributes({soID: parseInt(event.target.value)});
			}else props.setAttributes({soID: parseInt(event.target.value)});
		};
		const onChangeAlignment = ( newAlignment ) => {
            props.setAttributes( { soAlignment: newAlignment === undefined ? 'none' : newAlignment } );
            injectSOShortcode();
        };

		const changeToSmall = () => {
            props.setAttributes( { soSize: 'small' } );
            injectSOShortcode();
        };
		const changeToMedium = () => {
            props.setAttributes( { soSize: 'medium' } );
            injectSOShortcode();
        };
		const changeToWide = () => {
            props.setAttributes( { soSize: 'wide' } );
            injectSOShortcode();
        };

function _crop(){
    // image in dataUrl
    console.log(cropperRef.current.getCroppedCanvas().toDataURL());
  }
	    
	    return (
		    <div class={'soContainer '+ props.className} >
			    { props.attributes.soStep == finalStep && props.attributes.soID 
			    	? 
				    	<div>
					    	<Fragment>
					    		<InspectorControls>
					    			<PanelBody title="SquareOffs Settings" initialOpen={true}>
					    				<PanelRow>
					    					<TextControl
					    					label="SquareOff ID"
					    					onKeyUp={soUpdateSOID}
					    					onBlur={soUpdateSOID}
					    					defaultValue={props.attributes.soID}
					    					/>
					    				</PanelRow>
					    			</PanelBody>
					    		</InspectorControls>
					    	</Fragment>
					    
					    	<BlockControls>
		                        <BlockAlignmentToolbar
		                        	controls={['left', 'center', 'right']}
		                            value={props.attributes.soAlignment}
		                            onChange={ onChangeAlignment }
		                        />
			                    <Toolbar>
								    <IconButton
								      icon= {sSmallIcon}
								      label="Small"
								      value="small"
								      onClick={changeToSmall}
								    />
								    <IconButton
								      icon={sMediumIcon}
								      label="Medium"
								      value="medium"
								      onClick={ changeToMedium }
								    />
								    <IconButton
								      icon={sWideIcon}
								      label="Wide"
								      value="wide"
								      onClick={ changeToWide }
								    />
								</Toolbar>
							</BlockControls>
						</div>
					 : 
					 null
			    }
			    { props.attributes.soStep == finalStep
			    	? 
			    		<div>
				    		<div class="soClickHandle"></div>
				    		<ServerSideRender 
					    		block='squareoffs/blocks'
	    				        attributes={ {
	    				        	soID:props.attributes.soID,
	    				        	soSize:props.attributes.soSize,
	    				        	soAlignment:props.attributes.soAlignment
	    				        } }
    				    	/>
				    	</div>
				    : 
					<div class={'components-placeholder soCont'+props.attributes.soStep}>
				    	<img class="squareOffsLogo" src="https://squareoffs.com/assets/Logo-343c6a748ac336ca96afdf9d72fdeb3d70f1478434f3566ae459fd1707da8d18.svg" />
				    	{ props.attributes.soStep == 0 ?
					    	<div class="soStep soStep0">
					    		<Button isPrimary onClick={updateSOStep}>Create new SquareOff</Button>
					    		<Button isSecondary onClick={sOStepExisting}>Insert Existing SquareOff</Button>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep == 10 ?
					    	<div class="soStep soStep10">
					    		<h2>Insert Existing SquareOff</h2>
					    		<p><input onChange={soUpdateSOID} type="text" defaultValue={props.attributes.soID} placeholder="SquareOff ID"></input></p>
					    		<p><Button isPrimary onClick={injectSOShortcode}>Embed</Button>
					    		<Button isSecondary onClick={sOStepCancel}>Cancel</Button></p>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep == 1 ?
					    	<div class="soStep soStep1">
					    		{ !props.attributes.cover_photo_raw ?<p class="soCoverPhoto"><img src={window.soVars.soURL + 'assets/16x9.png'}/></p> :null }
									<Cropper
									ref={cropperRef}
									src={ props.attributes.cover_photo_raw }
									style={{height: 'auto', width: '100%'}}
									// Cropper.js options
									aspectRatio={16 / 9}
									guides={true}
									viewMode={1}
									crop={() => {props.setAttributes({cover_photo: cropperRef.current.getCroppedCanvas().toDataURL(props.attributes.cover_photo_mime)})}} />				    		

					    		<MediaUploadCheck>
			    					<MediaUpload
			    						onSelect={ ( media ) => {props.setAttributes({cover_photo_mime:media.mime}) ;props.setAttributes({cover_photo_raw:media.url}) }}
			    						allowedTypes='image'
			    						value={ props.attributes.coverPhotoMediaID }
			    						render={ ( { open } ) => (
			    							<Button isPrimary onClick={ open }>
			    								Add a Cover Photo (max. 5Mb)
			    							</Button>
			    						) }
			    					/>
			    				</MediaUploadCheck>

					    		<label>What is your question?</label>
					    		<p><textarea type="text" class={props.attributes.showRequired == 1 && !props.attributes.question ?'required':''} value={props.attributes.question} onChange={ ( event ) => props.setAttributes({question:event.target.value}) } placeholder="*What is your question?" maxLength="100"></textarea></p>
					    		<label>Side 1 Answer</label>
					    		<p><textarea type="text" class={props.attributes.showRequired == 1 && !props.attributes.side_1_title ?'required':''} value={ props.attributes.side_1_title} onChange={ ( event ) => props.setAttributes({side_1_title:event.target.value}) } placeholder="*Side 1 Answer" maxLength="20"></textarea></p>
					    		<label>Side 2 Answer</label>
					    		<p><textarea type="text" class={props.attributes.showRequired == 1 && !props.attributes.side_2_title ?'required':''} value={ props.attributes.side_2_title} onChange={ ( event ) => props.setAttributes({side_2_title:event.target.value}) } placeholder="*Side 2 Answer" maxLength="20"></textarea></p>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep == 2 ?
					    	<div class="soStep soStep3">
					    		<h2>Add a defense for each side (optional)</h2>
					    		<label>Side 1</label>
					    		<p><textarea type="text" value={ props.attributes.side_1_defense } onChange={(event) =>{props.setAttributes({side_1_defense:event.target.value})}} placeholder="Add more info, stats, or links to defend this side (optinal)." maxLength="600"></textarea></p>
					    		{props.attributes.side_1_photo ? <p class="soPhoto"><i class="removePhoto" onClick={(event) => {props.setAttributes({side_1_photo:null});}}>x</i><img src={props.attributes.side_1_photo}/></p>:null}

					    		<MediaUploadCheck>
			    					<MediaUpload
			    						onSelect={ ( media ) => props.setAttributes({side_1_photo:media.url}) }
			    						allowedTypes='image'
			    						value={ props.attributes.side1MediaID }
			    						render={ ( { open } ) => (
			    							<Button isSecondary onClick={ open }>
			    								Add a photo for side 1 (max. 5Mb)
			    							</Button>
			    						) }
			    					/>
			    				</MediaUploadCheck>
			    				<p><br/></p>
			    				<label>Side 2</label>
					    		<p><textarea type="text" value={ props.attributes.side_2_defense } onChange={(event) =>{props.setAttributes({side_2_defense:event.target.value})}} placeholder="Add more info, stats, or links to defend this side (optinal)." maxLength="600"></textarea></p>
					    		{props.attributes.side_2_photo ? <p class="soPhoto"><i class="removePhoto" onClick={(event) => {props.setAttributes({side_2_photo:null});}}>x</i><img src={props.attributes.side_2_photo}/></p>:null}

					    		<MediaUploadCheck>
			    					<MediaUpload
			    						onSelect={ ( media ) => props.setAttributes({side_2_photo:media.url}) }
			    						allowedTypes='image'
			    						value={ props.attributes.side2MediaID }
			    						render={ ( { open } ) => (
			    							<Button isSecondary onClick={ open }>
			    								Add a photo for side 2 (max. 5Mb)
			    							</Button>
			    						) }
			    					/>
			    				</MediaUploadCheck>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep == 3 ?
					    	<div class="soStep soStep4">
					    		<h2>Details</h2>
						    	
						    	<label for="socategory">Category</label>
						    	<p><select id="socategory" class={props.attributes.showRequired == 3 && !props.attributes.category_uuid ?'required':''} value={props.attributes.category_uuid} onChange={(event) =>{props.setAttributes({category_uuid:event.target.value})}}>
						    		<option value="">Category</option>
						    		<option value="e5e6883a-6e9c-4b7e-b247-43629ce4a5db">Life</option>
						    		<option value="a6840d90-1f50-4e8a-98d0-c1c1c5134a78">News</option>
						    		<option value="6c806976-e20c-4666-9d33-45896567c155">Sports</option>
						    	</select></p>
						    	
						    	<label for="soTags">Tags</label>
					    		<p><textarea type="text" id="soTags" value={props.attributes.tag_list} onChange={(event) =>{props.setAttributes({tag_list:event.target.value})}} placeholder="Comma separated Tags" maxLength="100"></textarea></p>

								<label for="endDate">End Date</label>
						    		<p><input type="text" id="endDate" value={ props.attributes.end_date } onFocus={handleEndDateFocus} /></p>
						    		{dateTimePickerFocus == true 
						    			? (
						    			<div class="DateTimePicker">
								    		<DateTimePicker
								    		    currentDate={ props.attributes.end_date }
								    		    onChange={ ( date ) => props.setAttributes( {end_date: date } ) }
								    		    is12Hour={ true }
								    		/>
								    		<Button isPrimary onClick={closeDatePicker}>OK</Button>
							    		</div>
							    		)
							    		:null
							    	}

			    				<label for="soSize">Size</label>
			    				<div class="soRadioSizes">
			    					<div>
			    						<i class="small" onClick={(event) => {props.setAttributes({soSize:'small'})}}></i>
			    						<input type="radio" value="small" checked={props.attributes.soSize === 'small'} onChange={(event) =>{props.setAttributes({soSize:event.target.value})}} />
			    					</div>
			    					<div>
			    						<i class="medium" onClick={(event) => {props.setAttributes({soSize:'medium'})}}></i>
			    						<input type="radio" value="medium" checked={props.attributes.soSize === 'medium'} onChange={(event) =>{props.setAttributes({soSize:event.target.value})}} />
			    					</div>
			    					<div>
			    						<i class="wide" onClick={(event) => {props.setAttributes({soSize:'wide'})}}></i>
			    						<input type="radio" value="wide" checked={props.attributes.soSize === 'wide'} onChange={(event) =>{props.setAttributes({soSize:event.target.value})}} />
			    					</div>
			    				</div>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep == fetchStep ?
					    	<div class="soStep soStep5" id={props.attributes.soStep}>
					    		<p>Please wait while we're creating your SquareOff...</p>
					    	</div>
					    	: null
					    }
					    { props.attributes.soStep !== 0 && props.attributes.soStep !== fetchStep && props.attributes.soStep !== finalStep && props.attributes.soStep !=10 ?
					    	<div class="btnControls">
					    		<Button isPrimary onClick={updateSOStep}>{props.attributes.soStep == fetchStep - 1 ? 'Submit':'Next'}</Button>
					    		{ props.attributes.soStep >1 ? <Button isSecondary onClick={backSOStep}>Back</Button> : null }
						    	<Button isTertiary onClick={sOStepCancel}>Cancel</Button>
					    	</div>
					    	: null
					    }
				    </div>
			    }
		    </div>
		);
  	},
    save: function() {
    	return null;
    },

} );

// export default Cropper;
